import { FunctionComponentType } from '@interfaces/FunctionComponentType'
import { withAuthenGuard } from '@libs/hoc/withAuthenGuard'
import MenuBar from '@components/AppLayout/components/MenuBar'
import { withHomeLayout } from './withHomeLayout'

const HomeLayout = ({ children }: FunctionComponentType) => {
  return (
    <>
      <div className='pt-[40px] pb-[80px] min-h-screen bg-gray-900'>
        {children}
      </div>
      <MenuBar />
    </>
  )
}

export default withAuthenGuard(withHomeLayout(HomeLayout))
